/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * Maximum length of text to display in an event list item.
 * @export
 */
export const MAX_CHARACTERS = 80;

export const EVENTS_LIST_TYPE_CUSTOM = `Custom`;
export const EVENTS_LIST_TYPE_PAGE_VIEW = `Page view`;
export const EVENTS_LIST_TYPE_LOGIN = `Login`;
export const EVENTS_LIST_TYPE_VISIT = `Visit`;

export const EVENTS_LIST_SOURCE_WEB_BEHAVIOR = `Website behavior`;
export const EVENTS_LIST_SOURCE_DATA_INTEGRATION = `Data integration`;
